<mat-card>
    <mat-card-header>
      <mat-card-title>Gestión de Tipo de Gasto</mat-card-title>
      <mat-card-subtitle></mat-card-subtitle>
    </mat-card-header>
  
    <mat-card-content>
  
      <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
      <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
      <mat-label *ngIf="!isSearching && msgError.length > 0">{{msgError}}</mat-label>
  
      <div *ngIf="!isSearching && item != null">
  
        <ng-container *ngIf="canEdit">
  
          <form [formGroup]="formGroup">
  
            <mat-expansion-panel [expanded]="true">

              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon style="margin-top: -3px;">settings</mat-icon> Datos Generales
                </mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <div fxLayout="row stretch" fxLayout.xs="column">

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Código*</mat-label>
                    <input matInput formControlName="Codigo" (keyup.enter)="onGuardar()" maxlength="100"> 
                    <mat-icon matSuffix>search</mat-icon>
                    <mat-error *ngIf="!formGroup.controls['Codigo'].valid && formGroup.controls['Codigo'].touched">
                      {{ getErrorCodigo() }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Nombre*</mat-label>
                    <input matInput formControlName="Nombre" (keyup.enter)="onGuardar()" maxlength="150">
                    <mat-error *ngIf="!formGroup.controls['Nombre'].valid && formGroup.controls['Nombre'].touched">
                      {{ getErrorNombre() }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <ng-container *ngIf="canRecurrente">

                  <div fxFlex=50 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item" style="margin-top: 20px;">
                    <mat-checkbox formControlName="EsRecurrente" (keyup.enter)="onGuardar()" color="primary">Los gastos de este tipo son recurrentes?</mat-checkbox> 
                  </div>
                  <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="formGroup?.get('EsRecurrente')?.value == true">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>Periodicidad de Recurrencia (días)*</mat-label>
                      <input matInput type="number" formControlName="PeriodicidadRecurrencia" (keyup.enter)="onGuardar()" maxlength="10">
                      <!-- <mat-error *ngIf="!formGroup.controls['Nombre'].valid && formGroup.controls['Nombre'].touched">
                        {{ getErrorNombre() }}
                      </mat-error> -->
                    </mat-form-field>
                  </div>

                </ng-container>

                <div fxFlex=50 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item" style="margin-top: 20px;">
                  <mat-checkbox class="text-style" formControlName="Activo" (keyup.enter)="onGuardar()" color="primary">Activo</mat-checkbox>
                </div>

              </div>

            </mat-expansion-panel>
  
          </form>
  
        </ng-container>
  
        <ng-container *ngIf="!canEdit">
  
          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">settings</mat-icon> Datos Generales
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" class="zb-readonly">
    
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Código</b>: {{item.Codigo}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Nombre</b>: {{item.Nombre}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <ng-container *ngIf="canRecurrente">

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Es Recurrente</b>: {{item.EsRecurrente ? 'Sí' : 'No'}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="item.EsRecurrente">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Periodicidad de Recurrencia (días)</b>: {{item.PeriodicidadRecurrencia | number: '1.2-2'}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>

              </ng-container>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Activo</b>: {{item.Activo ? 'Sí' : 'No'}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
    
            </div>

          </mat-expansion-panel>
  
        </ng-container>
  
        <!--TIPO GASTOS EDIT-->
        <ng-container *ngIf="tenantFeatureFlags?.HabilitarControlGastos">
          <br/>
          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-right: 5px;">attach_money</mat-icon> Tipos de Gastos
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <form [formGroup]="comunidadesFormGroup" *ngIf="canEdit">

              <div fxLayout="row stretch" fxLayout.xs="column">
  
                <div fxFlex=45 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label *ngIf="!isComunidadSearching">{{'Comunidad' | translate}}</mat-label>
                    <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
                    <mat-select formControlName="ComunidadId">
                      <mat-option *ngFor="let s of comunidadList" [value]="s.Id">{{s.Nombre}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="!comunidadesFormGroup.controls['ComunidadId'].valid && comunidadesFormGroup.controls['ComunidadId'].touched">
                      {{ getErrorComunidadId() }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex=45 fxFlex.xs=100 class="flex-item" fxLayoutAlign="center" style="margin-top: 15px;" *ngIf="tenantFeatureFlags?.HabilitarControlExpensas">
                  <!-- <mat-form-field appearance="outline" style="width: 100%"> -->
                    <mat-checkbox formControlName="MostrarEnResumenExpensa">Mostrar este gasto/{{('Comunidad' | translate).toLowerCase()}} en las columnas de expensas</mat-checkbox>
                  <!-- </mat-form-field> -->
                </div>
                <div fxFlex=10 fxFlex.xs=100 class="flex-item" style="margin-top:10px;" align="end">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <button mat-raised-button (click)="onComunidadAdd()" [disabled]="isProcessing()" color="primary"
                      class="zb-button">Agregar</button>
                  </div>
                </div>
  
              </div>
  
            </form>
  
            <div fxLayout="row stretch" fxLayout.xs="column">
              <ejs-grid #comunidadesGrid [dataSource]='item.Comunidades' [allowPaging]="true" [allowSorting]="true"
                [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
                [allowResizing]='true'>
                <e-columns>
                  <e-column field='Comunidad' headerText="{{'Comunidad' | translate}}" width="200"></e-column>
                  <e-column field='MostrarEnResumenExpensa' headerText='Mostrar en Expensas' width="70" *ngIf="tenantFeatureFlags?.HabilitarControlExpensas">
                    <ng-template #template let-data>
                      {{data.MostrarEnResumenExpensa ? 'Sí' : 'No'}}
                    </ng-template>
                  </e-column>
                  <e-column headerText='Acciones' width="70" *ngIf="canEdit">
                    <ng-template #template let-data>
                      <a style="cursor: pointer; margin-right: 5px" (click)="onComunidadDelete(data)" title="Eliminar">
                        <i class="fa fa-trash fa-1x"></i>
                      </a>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>
            </div>

          </mat-expansion-panel>
        </ng-container>

      </div>
  
    </mat-card-content>
  
    <mat-card-actions style="margin-bottom: 20px;">
      <div fxLayout="row stretch" fxLayout.xs="column">
        <button mat-raised-button (click)="onGuardar()" *ngIf="canEdit" [disabled]="isProcessing()" color="primary" class="zb-button">{{isSaving ? 'Guardando...' : 'Guardar'}}</button>
        <button mat-raised-button (click)="onCancel()" color="warn" class="zb-button">{{canEdit ? 'Cancelar' : 'Cerrar'}}</button>
        <button mat-raised-button (click)="onDelete()" *ngIf="canDelete && item != null && item.Id > 0" [disabled]="isSaving" color="warn" class="zb-button">
          {{ isDeleting ? 'Eliminando...' : 'Eliminar' }}
        </button>    
      </div>
    </mat-card-actions>
  
  </mat-card>